import * as React from 'react';
import DownloadIcon from '@mui/icons-material/Download'
import { GPAP_Button_light } from "../../../../../gpap-lib/Button_Collection";


const TsvTemplate =(props)=>{

    return(
        <GPAP_Button_light
            style={{float:"left"}}
            id="download"
            startIcon={<DownloadIcon/>}
            onClick={props.onClick}>
                TSV TEMPLATE
        </GPAP_Button_light>
    );
}

export default TsvTemplate;